/**
 * Created by shiying on 2017/4/29.
 */

module.exports = {
    product : require("./fdapi/product.js"),
    orderCenter : require("./fdapi/orderCenter.js")
}


//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/fdapi.js
// module id = 5
// module chunks = 0